import { jsx as _jsx } from "react/jsx-runtime";
// TODO: this needs to be moved to the portal lib
import { useRef } from 'react';
import { RefsProvider } from '@zurich/common/contexts';
import { useTranslation } from '@zurich/common/hooks';
import { useAlertDialog } from '../../hooks';
import { styled } from '../../utils';
import { Dialog } from '../Dialog';
import { DialogStepper } from './DialogStepper';
export function FieldsDialog({ steps, onSave, loading, onDiscardChanges, discardChanges, discardTitle, discardDescription, discardCancelText, discardContinueText, stepnavigationNextLabel, stepnavigationPrevLabel, stepnavigationLastLabel, buttonPosition, scrollToError, oneStepHideCancelButton = false, ...dialogProps }) {
    const { t } = useTranslation();
    const setAlertDialog = useAlertDialog();
    const contentRef = useRef(null);
    const handleSave = () => {
        if (onSave)
            onSave();
        else if (dialogProps.onClose)
            dialogProps.onClose({}, 'backdropClick');
    };
    const handleClose = () => {
        if (discardChanges) {
            // open discard alert with default text
            setAlertDialog({
                title: discardTitle || t('common:discardDialog.title'),
                description: discardDescription || t('common:discardDialog.description'),
                cancelAction: true,
                cancelText: discardCancelText || 'Zurück zur Bearbeitung',
                continueText: discardContinueText || 'Trotzdem abbrechen',
                onContinue: () => {
                    if (onDiscardChanges)
                        onDiscardChanges();
                    if (dialogProps.onClose)
                        dialogProps.onClose({}, 'backdropClick');
                },
            });
        }
        else if (dialogProps.onClose)
            dialogProps.onClose({}, 'backdropClick');
    };
    return (_jsx(RefsProvider, { children: _jsx(DialogStyled, { showCloseIcon: !loading, contentRef: contentRef, ...dialogProps, onClose: handleClose, children: _jsx(DialogStepper, { steps: steps, onSave: handleSave, onClose: handleClose, stepnavigationNextLabel: stepnavigationNextLabel, stepnavigationPrevLabel: stepnavigationPrevLabel, stepnavigationLastLabel: stepnavigationLastLabel, loading: loading, contentRef: contentRef, buttonPosition: buttonPosition, scrollToError: scrollToError, oneStepHideCancelButton: oneStepHideCancelButton }) }) }));
}
const DialogStyled = styled(Dialog)(() => ({
    '.MuiDialog-root.MuiDialogContent-root': {
        overflowY: 'hidden',
        display: 'flex',
        flexDirection: 'column',
    },
}));
